import axios from "axios";

let DAGENSBOG_API_URL = "https://api.zevio.com/"; // Should switch depending on build
let DAGENSBOG_CONTEXT = "development";

if (
	window.location.hostname.includes("dagensbog")
) {
	DAGENSBOG_API_URL = 'https://api.zevio.com/';
	DAGENSBOG_CONTEXT = 'production';
}

export const APIGet = (resource, params = {}) => {
	const url = DAGENSBOG_API_URL + resource;
	const options = { params, headers: {} };

	if (DAGENSBOG_CONTEXT !== "production")
		console.log([DAGENSBOG_API_URL, "APIGet", resource, params]);

	return axiosWithRetryMutex({ url, method: "get", ...options })
};

export const APIPost = (resource, body, headers = { "Content-Type": "application/json" }) => {
	const url = DAGENSBOG_API_URL + resource;
	if (DAGENSBOG_CONTEXT !== "production")
		console.log([DAGENSBOG_API_URL, "APIPost", resource, body]);

	return axiosWithRetryMutex({ url, method: "post", data: body, headers })
};

export const APIDelete = (resource, data = {}) => {
	const url = DAGENSBOG_API_URL + resource;
	const headers = {};
	if (DAGENSBOG_CONTEXT !== "production")
		console.log([DAGENSBOG_API_URL, 'APIDelete', resource, data]);

	return axiosWithRetryMutex({ url, method: "delete", data, headers })
};

const axiosWithRetryMutex = (options) => {
	return axios(options);
};

let fetchStatus = "pending"
let response
export const wrapPromise = (promise, key) => {
	const suspender = promise.then(
		(res) => {
			fetchStatus = 'success'
			response = res[key]
		},
		(err) => {
			fetchStatus = 'error'
			response = err
		},
	)

	return () => {
		switch (fetchStatus) {
			case 'pending':
				throw suspender
			case 'error':
				throw response
			default:
				return response
		}
	}
}
